module.exports = __webpack_public_path__ + "img/anuenciaCons3.22cd3cef.jpg";